import { useState } from 'react';

import type { Props as CreatFiatWalletProps } from '../CreateFiatWallet';
import { CreateFiatWallet } from '../CreateFiatWallet';
import type { Props as InterstitialContextModalProps } from '../InterstitialContextModal';
import { InterstitialContextModal } from '../InterstitialContextModal';

type Props = Omit<InterstitialContextModalProps, 'onAccept'> &
  CreatFiatWalletProps;

export const CreateFiatWalletWithInterstitialModal = ({
  onDecline,
  mode,
  onClose,
  ...createFiatWalletProps
}: Props) => {
  const [showCreateFiatWallet, setShowCreateFiatWallet] = useState(false);

  if (showCreateFiatWallet) {
    return (
      <CreateFiatWallet
        {...createFiatWalletProps}
        onClose={() => {
          setShowCreateFiatWallet(false);
          onClose();
        }}
      />
    );
  }

  return (
    <InterstitialContextModal
      onAccept={() => setShowCreateFiatWallet(true)}
      {...{ onDecline, mode }}
    />
  );
};
